let today = (new Date()).getFullYear() + '-' + ((new Date()).getMonth()+1) + '-' + (new Date()).getDate(),
    transfer_date = today,
    transfer_time = '09:00:00'

export const private_data = {
    supplier: '',
    supplier_quote_id: '',
    supplier_price: '',
    private_notes: '',
    supplier_price_details: [],
}

export const public_data = {
    public_price: '',
    public_notes: '',
    agent_notes: '',
    service_notes: '',
    links: [
    ]
}

export const gallery = {
    url: '',
    caption: '',
}

export const link = {
    a: '',
    href: '',
}

export const room = {
    qty: 0,
    room_name: '',
    bedding: '',
    treatment: '',
}

export const transfer = {
    date: transfer_date,
    time: transfer_time,
    from: '',
    to: '',
    date_time_friendly: transfer_date + ' - ' + transfer_time,
}

export const document = {
    a: '',
    href: '',
}

/*
export function new_quote() {
    return {
        request_id: '',
        user_id: '',
        created_at: today,
        details: {
            grand_total: '',
            gallery: [
                gallery
            ]
        },
        services: [
        ],
    }
}
*/

export function add_service_to_quote(quote,type)
{
    let service_index = 0
    quote.services.forEach(service => {
      if(service.service_index >= service_index) service_index = service.service_index + 1
    })


    switch (type) {
        case 'overnight':
            return new_service_overnight(service_index)
    
        case 'flight':
            return new_service_flight(service_index)
        
        case 'transfer':
            return new_service_transfer(service_index)
    
        case 'insurance':
            return new_service_insurance(service_index)
    
        case 'generic':
            return new_service_generic(service_index)

        case 'package':
          return new_service_package(service_index)
    
        default:
            break;
    }
}

export function new_service_generic(service_index) {
    return {
        service_index: service_index,
        type: 'generic',
        details: {
            type: 'generic',
            title: 'Generico #'+(service_index + 1),
            freetext: ''
        },
        private_data: private_data,
        public_data: public_data,
    }
}

export function new_service_overnight(service_index) {
    return {
        service_index: service_index,
        type: 'overnight',
        details: {
            type: 'overnight',
            title: 'Pernottamento #'+(service_index + 1),
            hotels: [],
        },
        private_data: private_data,
        public_data: public_data,
    }
}

export function new_service_flight(service_index) {
    return {
        service_index: service_index,
        type: 'flight',
        details: {
            type: 'flight',
            title: 'Volo #'+(service_index + 1),
            itineraries: [],
        },
        private_data: private_data,
        public_data: public_data,
    }
}

export function new_flight_itinerary(itinerary_index) {
    return {
        itinerary_index: itinerary_index,
        duration: 'PT00H00M',
        segments: [
            new_flight_segment(0)
        ],
    }
}

export function new_flight_segment(segment_index) {
    return {
        segment_index: segment_index,
        departure:{
            iataCode:'',
            at: today + 'T9:00'
        },
        arrival:{
            iataCode:'',
            at: today + 'T9:00'
        },
        carrierCode:'',
            operating:{
            carrierCode:''
        },
    }
}

export function new_overnight_hotel(hotel_index) {
    // usato anche per service 'package'

    let checkin_date = new Date(),
        checkout_date = new Date()
    
    checkout_date.setDate(checkin_date.getDate() + 7)

    return {
        hotel_index: hotel_index,
        type: 'hotel',
        title: 'Hotel #'+(hotel_index + 1),
        eps_property_id: 0,
        property_name: '',
        address: '',
        city: '',
        country_code: '',
        checkin: checkin_date.getFullYear() + '-' + (checkin_date.getMonth()+1) + '-' + checkin_date.getDate(),//'2022-06-02',
        checkout: checkout_date.getFullYear() + '-' + (checkout_date.getMonth()+1) + '-' + checkout_date.getDate(),//'2022-06-02',
        rooms: [
            room
        ],
        property_amenities: [
        ],
        cover_url: process.env.VUE_APP_SHOP_HOST + 'assets/default_overnight_cover.jpg',
        gallery: [
          process.env.VUE_APP_SHOP_HOST + 'assets/default_overnight_cover.jpg'
        ]
    }
}

export function new_service_transfer(service_index) {
    return {
        service_index: service_index,
        type: 'transfer',
        details: {
            type: 'transfer',
            title: 'Transfer #'+(service_index + 1),
            //car_type: '',
            transfers: [
                //transfer
            ],
            details: '',
        },
        private_data: private_data,
        public_data: public_data,
    }
}

export function new_service_insurance(service_index) {
    return {
        service_index: service_index,
        type: 'insurance',
        details: {
            type: 'insurance',
            title: 'Insurance #'+(service_index + 1),
            freetext: '',
            documents: [
                document
            ]
        },
        private_data: private_data,
        public_data: public_data,
    }
}

export function new_service_package(service_index) {
  return {
    service_index: service_index,
    type: 'package',
    details: {
      type: 'package',
      title: 'Pacchetto #'+(service_index + 1),
      hotels: [],
    },
    private_data: private_data,
    public_data: public_data,
  }
}